import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { Location } from '@angular/common';
import { LocalStorageKeys } from '../../constants/LocalStorageKeys';

@Injectable()
export class AuthGuardService implements CanActivate {
  constructor(public router: Router, private location: Location) {}
  canActivate(route:ActivatedRouteSnapshot): boolean {
    console.log(route.url[0]);
    if (localStorage.getItem(LocalStorageKeys.LoginToken) === null) {
      this.router.navigate(['login']);
      return false;
    }
    return true;
  }
}